import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export interface EmptyStateProps {
	icon?: React.ReactNode;
	title: string;
	description?: string;
	primaryActionLabel?: string;
	onPrimaryAction?: () => void;
	secondaryActionLabel?: string;
	onSecondaryAction?: () => void;
}

export function EmptyState({
	icon,
	title,
	description,
	primaryActionLabel,
	onPrimaryAction,
	secondaryActionLabel,
	onSecondaryAction,
}: EmptyStateProps): React.JSX.Element {
	return (
		<Stack
			alignItems="center"
			spacing={2}
			sx={{
				py: 8,
				px: 3,
				textAlign: "center",
				bgcolor: "var(--mui-palette-background-paper)",
				border: "1px dashed var(--mui-palette-divider)",
				borderRadius: 2,
			}}>
			{icon && (
				<Box sx={{ color: "var(--mui-palette-text-secondary)" }}>{icon}</Box>
			)}
			<Stack
				spacing={1}
				sx={{ maxWidth: 480 }}>
				<Typography variant="h6">{title}</Typography>
				{description && (
					<Typography
						variant="body2"
						color="text.secondary">
						{description}
					</Typography>
				)}
			</Stack>
			{(primaryActionLabel ?? secondaryActionLabel) && (
				<Stack
					direction="row"
					spacing={1.5}
					sx={{ mt: 1 }}>
					{secondaryActionLabel && onSecondaryAction && (
						<Button
							variant="text"
							onClick={onSecondaryAction}>
							{secondaryActionLabel}
						</Button>
					)}
					{primaryActionLabel && onPrimaryAction && (
						<Button
							variant="contained"
							onClick={onPrimaryAction}>
							{primaryActionLabel}
						</Button>
					)}
				</Stack>
			)}
		</Stack>
	);
}
